import React from 'react';
import { displayErrorMessage } from 'Helpers/FacetNotificationManager';

export default function useConfirmationDialogState({
  onClose = () => {},
  onSubmit = async () => {},
  errorConfig = {},
  closeOnSubmit = false,
  onOpen = () => {},
}) {
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  const handleOpen = (e) => {
    setDialogOpen(true);
    onOpen(e);
  };

  const handleClose = (e) => {
    setDialogOpen(false);
    onClose(e);
  };

  const handleSubmit = async (e) => {
    setLoading(true);
    try {
      return await onSubmit(e);
    } catch (err) {
      displayErrorMessage(errorConfig.error || err, errorConfig.message || err.errors);
    } finally {
      setLoading(false);
      if (closeOnSubmit) {
        handleClose();
      }
    }
    return null;
  };

  return {
    handleClose,
    handleSubmit,
    handleOpen,
    dialogOpen,
    loading,
  };
}
